import { Component, OnInit } from '@angular/core';

@Component({
  selector: 'auth-layout-root',
  templateUrl: './auth-layout.component.html',
  styleUrls: ['./auth-layout.component.scss']
})
export class AuthLayoutComponent implements OnInit {
  constructor() {}

  ngOnInit() {}
}
